/** Fase 2 (W9): textos de filas, e-mail, anexos, janela de 24 h e assinatura, nos três idiomas (sem travessão nem emoji). */
const pt = {
  w9: {
    canais: { whatsapp: 'WhatsApp', instagram: 'Instagram', email: 'E-mail', portal: 'Portal do cliente', site: 'Chat do site' },
    fila: 'Fila',
    caixa: 'Caixa',
    de: 'De',
    para: 'Para',
    assunto: 'Assunto',
    semAssunto: 'Sem assunto',
    mostrarImagens: 'Mostrar imagens',
    imagensBloqueadas_one: '{{count}} imagem externa bloqueada para proteger a sua privacidade.',
    imagensBloqueadas_other: '{{count}} imagens externas bloqueadas para proteger a sua privacidade.',
    htmlDiscreto: 'Modo discreto ligado: o e-mail aparece só como texto.',
    conteudoEmail: 'Conteúdo do e-mail de {{de}}',
    baixar: 'Baixar {{nome}}',
    abrirImagem: 'Abrir a imagem {{nome}}',
    anexosRecusados: 'Arquivos não guardados',
    midiaErro: {
      muito_grande: 'Arquivo maior que o limite de 25 MB, não foi guardado.',
      tipo_nao_permitido: 'Tipo de arquivo não permitido, não foi guardado.',
      indisponivel: 'O arquivo não está mais disponível no provedor.',
      vazio: 'Arquivo vazio, não foi guardado.',
      excedente: 'Mais de 10 anexos no e-mail: este ficou de fora.',
    },
    caixasMonitoradas: 'Caixas monitoradas',
    sincronizada: 'sincronizada {{quando}}',
    nuncaSincronizada: 'aguardando a primeira sincronização',
    comErro: 'com erro na última sincronização',
  },
  janela: {
    fechada: 'Passaram 24 horas desde a última mensagem do contato. No WhatsApp, só um modelo de mensagem aprovado reabre a conversa.',
    enviarTemplate: 'Enviar modelo de mensagem',
    expira: 'Janela de 24 horas aberta até {{quando}}',
  },
  anexos: {
    anexar: 'Anexar arquivo',
    remover: 'Remover {{nome}}',
    enviando: 'Enviando o arquivo',
    umPorMensagem: 'Neste canal (WhatsApp ou Portal), vai um arquivo por mensagem.',
    limite: 'Até 25 MB somados. Imagem, PDF, documento do Office, áudio ou vídeo.',
  },
  emailComposer: {
    placeholder: 'Escreva a resposta. Ela vai para a mesma conversa de e-mail.',
    dica: 'Enter quebra a linha e Ctrl+Enter envia. A sua assinatura entra no fim.',
    assinatura: 'Assinatura',
  },
  assinatura: {
    titulo: 'Assinatura de e-mail',
    texto: 'Entra no fim das suas respostas pelo e-mail. Deixe vazio para responder sem assinatura.',
    campo: 'Assinatura',
    sucesso: 'Assinatura salva',
  },
  filas: {
    nova: 'Nova fila',
    nome: 'Nome',
    distribuicao: 'Como dividir as conversas',
    canais: 'Canais',
    membros: 'Membros',
    ativa: 'Fila ativa',
    inativa: 'Inativa',
    conversasAtivas: 'Conversas ativas',
    distribuicoes: { manual: 'Manual', rodizio: 'Rodízio', menor_carga: 'Menor carga' },
    ajudaDistribuicao: 'Manual: a conversa nova avisa os membros e alguém assume. Rodízio: vai direto para o próximo membro, um de cada vez.',
    ajudaCanais: 'A conversa nova destes canais entra nesta fila.',
    ajudaMembros: 'Quem é membro vê as conversas desta fila e recebe os avisos dela.',
    semCanal: 'Só por transferência',
    semMembros: 'Nenhum membro',
    membrosCount_one: '{{count}} membro',
    membrosCount_other: '{{count}} membros',
    vazio: 'Fila é um grupo de pessoas que atende junto. Crie a primeira para separar o atendimento por equipe. Sem fila, toda conversa aparece para quem atende.',
    vazioTitulo: 'Nenhuma fila ainda',
    removerTitulo: 'Excluir esta fila?',
    removerTexto: 'As conversas dela ficam sem fila e aparecem para quem atende.',
    carregandoMembros: 'Carregando os usuários',
    escopo: 'Quem tem a permissão "ver todas as conversas" vê todas as filas.',
  },
  transferirFila: { fila: 'Fila', manter: 'Manter a fila atual', semFila: 'Sem fila', ajuda: 'Numa fila em rodízio, sem atendente escolhido, a conversa vai para o próximo membro.' },
};

type Dic = typeof pt;

const en: Dic = {
  w9: {
    canais: { whatsapp: 'WhatsApp', instagram: 'Instagram', email: 'Email', portal: 'Customer portal', site: 'Website chat' },
    fila: 'Queue',
    caixa: 'Mailbox',
    de: 'From',
    para: 'To',
    assunto: 'Subject',
    semAssunto: 'No subject',
    mostrarImagens: 'Show images',
    imagensBloqueadas_one: '{{count}} external image blocked to protect your privacy.',
    imagensBloqueadas_other: '{{count}} external images blocked to protect your privacy.',
    htmlDiscreto: 'Discreet mode is on: the email shows as plain text only.',
    conteudoEmail: 'Email content from {{de}}',
    baixar: 'Download {{nome}}',
    abrirImagem: 'Open image {{nome}}',
    anexosRecusados: 'Files not stored',
    midiaErro: {
      muito_grande: 'File larger than the 25 MB limit, not stored.',
      tipo_nao_permitido: 'File type not allowed, not stored.',
      indisponivel: 'The file is no longer available at the provider.',
      vazio: 'Empty file, not stored.',
      excedente: 'More than 10 attachments in the email: this one was left out.',
    },
    caixasMonitoradas: 'Monitored mailboxes',
    sincronizada: 'synced {{quando}}',
    nuncaSincronizada: 'waiting for the first sync',
    comErro: 'last sync failed',
  },
  janela: {
    fechada: 'More than 24 hours have passed since the contact last wrote. On WhatsApp, only an approved template reopens the conversation.',
    enviarTemplate: 'Send message template',
    expira: '24 hour window open until {{quando}}',
  },
  anexos: {
    anexar: 'Attach file',
    remover: 'Remove {{nome}}',
    enviando: 'Uploading the file',
    umPorMensagem: 'In this channel (WhatsApp or Portal), one file goes per message.',
    limite: 'Up to 25 MB in total. Image, PDF, Office document, audio or video.',
  },
  emailComposer: {
    placeholder: 'Write your reply. It goes to the same email conversation.',
    dica: 'Enter adds a line and Ctrl+Enter sends. Your signature goes at the end.',
    assinatura: 'Signature',
  },
  assinatura: {
    titulo: 'Email signature',
    texto: 'Added at the end of your email replies. Leave it empty to reply without a signature.',
    campo: 'Signature',
    sucesso: 'Signature saved',
  },
  filas: {
    nova: 'New queue',
    nome: 'Name',
    distribuicao: 'How to split conversations',
    canais: 'Channels',
    membros: 'Members',
    ativa: 'Active queue',
    inativa: 'Inactive',
    conversasAtivas: 'Active conversations',
    distribuicoes: { manual: 'Manual', rodizio: 'Round robin', menor_carga: 'Least load' },
    ajudaDistribuicao: 'Manual: a new conversation notifies the members and someone takes it. Round robin: it goes straight to the next member, one at a time.',
    ajudaCanais: 'New conversations from these channels enter this queue.',
    ajudaMembros: 'Members see the conversations in this queue and get its notifications.',
    semCanal: 'Transfers only',
    semMembros: 'No members',
    membrosCount_one: '{{count}} member',
    membrosCount_other: '{{count}} members',
    vazio: 'Create queues to split support by team. Without a queue, every conversation shows up for everyone who answers.',
    vazioTitulo: 'No queues yet',
    removerTitulo: 'Delete this queue?',
    removerTexto: 'Its conversations stay without a queue and show up for everyone who answers.',
    carregandoMembros: 'Loading users',
    escopo: 'Anyone with the "see all conversations" permission sees every queue.',
  },
  transferirFila: { fila: 'Queue', manter: 'Keep the current queue', semFila: 'No queue', ajuda: 'In a round robin queue, with no agent picked, the conversation goes to the next member.' },
};

const es: Dic = {
  w9: {
    canais: { whatsapp: 'WhatsApp', instagram: 'Instagram', email: 'Correo', portal: 'Portal del cliente', site: 'Chat del sitio' },
    fila: 'Cola',
    caixa: 'Buzón',
    de: 'De',
    para: 'Para',
    assunto: 'Asunto',
    semAssunto: 'Sin asunto',
    mostrarImagens: 'Mostrar imágenes',
    imagensBloqueadas_one: '{{count}} imagen externa bloqueada para proteger tu privacidad.',
    imagensBloqueadas_other: '{{count}} imágenes externas bloqueadas para proteger tu privacidad.',
    htmlDiscreto: 'Modo discreto activado: el correo se muestra solo como texto.',
    conteudoEmail: 'Contenido del correo de {{de}}',
    baixar: 'Descargar {{nome}}',
    abrirImagem: 'Abrir la imagen {{nome}}',
    anexosRecusados: 'Archivos no guardados',
    midiaErro: {
      muito_grande: 'Archivo mayor que el límite de 25 MB, no se guardó.',
      tipo_nao_permitido: 'Tipo de archivo no permitido, no se guardó.',
      indisponivel: 'El archivo ya no está disponible en el proveedor.',
      vazio: 'Archivo vacío, no se guardó.',
      excedente: 'Más de 10 adjuntos en el correo: este quedó fuera.',
    },
    caixasMonitoradas: 'Buzones monitoreados',
    sincronizada: 'sincronizado {{quando}}',
    nuncaSincronizada: 'esperando la primera sincronización',
    comErro: 'con error en la última sincronización',
  },
  janela: {
    fechada: 'Pasaron 24 horas desde el último mensaje del contacto. En WhatsApp, solo una plantilla aprobada reabre la conversación.',
    enviarTemplate: 'Enviar plantilla de mensaje',
    expira: 'Ventana de 24 horas abierta hasta {{quando}}',
  },
  anexos: {
    anexar: 'Adjuntar archivo',
    remover: 'Quitar {{nome}}',
    enviando: 'Subiendo el archivo',
    umPorMensagem: 'En este canal (WhatsApp o Portal), va un archivo por mensaje.',
    limite: 'Hasta 25 MB en total. Imagen, PDF, documento de Office, audio o video.',
  },
  emailComposer: {
    placeholder: 'Escribe la respuesta. Va a la misma conversación de correo.',
    dica: 'Enter agrega una línea y Ctrl+Enter envía. Tu firma va al final.',
    assinatura: 'Firma',
  },
  assinatura: {
    titulo: 'Firma de correo',
    texto: 'Va al final de tus respuestas por correo. Déjala vacía para responder sin firma.',
    campo: 'Firma',
    sucesso: 'Firma guardada',
  },
  filas: {
    nova: 'Nueva cola',
    nome: 'Nombre',
    distribuicao: 'Cómo repartir las conversaciones',
    canais: 'Canales',
    membros: 'Miembros',
    ativa: 'Cola activa',
    inativa: 'Inactiva',
    conversasAtivas: 'Conversaciones activas',
    distribuicoes: { manual: 'Manual', rodizio: 'Rotación', menor_carga: 'Menor carga' },
    ajudaDistribuicao: 'Manual: la conversación nueva avisa a los miembros y alguien la toma. Rotación: va directo al siguiente miembro, uno a la vez.',
    ajudaCanais: 'La conversación nueva de estos canales entra en esta cola.',
    ajudaMembros: 'Quien es miembro ve las conversaciones de esta cola y recibe sus avisos.',
    semCanal: 'Solo por transferencia',
    semMembros: 'Ningún miembro',
    membrosCount_one: '{{count}} miembro',
    membrosCount_other: '{{count}} miembros',
    vazio: 'Crea colas para separar la atención por equipo. Sin cola, toda conversación aparece para quien atiende.',
    vazioTitulo: 'Ninguna cola todavía',
    removerTitulo: '¿Eliminar esta cola?',
    removerTexto: 'Sus conversaciones quedan sin cola y aparecen para quien atiende.',
    carregandoMembros: 'Cargando los usuarios',
    escopo: 'Quien tiene el permiso "ver todas las conversaciones" ve todas las colas.',
  },
  transferirFila: { fila: 'Cola', manter: 'Mantener la cola actual', semFila: 'Sin cola', ajuda: 'En una cola con rotación, sin agente elegido, la conversación va al siguiente miembro.' },
};

export const w9 = { pt, en, es };
